import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams} from 'prod-shared';
import {HttpClient} from "@angular/common/http";
import {Firmware} from "../models/firmware";

@Injectable({providedIn: 'root'})
export class FirmwareService implements IProdGridService {
  constructor(private httpClient: HttpClient) {
  }

  getProdGridData(httpExtraParams?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: Firmware[], totalCount: number }, success: boolean }>(`/api/firmwares`, {params: httpExtraParams});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/uploadFirmware`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch<any>(`/api/firmware/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    return this.httpClient.delete(`/api/firmware/${id}`);
  }
}
